import { IChartInfo } from "../../common/interfaces/chart.interface";
import { ITreasuryOverview } from "../../common/interfaces/treasury.interface";
import { get } from "../utilities/http";
import {
  TREASURY_OVERVIEW,
  TREASURY_BUY_CHART_INFO,
  TREASURY_SELL_CHART_INFO,
} from "../utilities/urls";

export function geTreasuryOverview(): Promise<ITreasuryOverview> {
  return get(TREASURY_OVERVIEW);
}

export function getBuyChartInfo(): Promise<IChartInfo> {
  return get(TREASURY_BUY_CHART_INFO);
}

export function getSellChartInfo(): Promise<IChartInfo> {
  return get(TREASURY_SELL_CHART_INFO);
}
